import styled from "styled-components";

export const CustomButton = styled("button")`
	position: relative;
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;

	&.learn-more-card {
		position: absolute;
		z-index: 1;
		top: 0.5em;
		right: 0.5em;
	}

	&.loyalty-shop {
		position: absolute;
		top: 1.2em;
		right: 0.1em;
	}
`;
